import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      ...(item.href ? { item: `https://depanvolets-strasbourg.fr${item.href}` } : {}),
    })),
  };

  return (
    <>
      <nav aria-label="Fil d'ariane" className="bg-background-100 border-b border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <ol className="flex items-center flex-wrap gap-1 py-2.5 text-xs md:text-sm text-foreground-600">
            {items.map((item, index) => {
              const isLast = index === items.length - 1;
              return (
                <li key={item.label + index} className="flex items-center">
                  {index > 0 && (
                    <span className="mx-1.5 text-foreground-400">/</span>
                  )}
                  {isLast || !item.href ? (
                    <span className="text-foreground-800 font-medium" aria-current="page">
                      {item.label}
                    </span>
                  ) : (
                    <Link
                      to={item.href}
                      className="text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {item.label}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  );
}